<script>
import {usePropertyStore} from "@/stores/modules/property.module";
import PropertyItemUser from "@/components/property/PropertyItemUser.vue";
import {useMapStore} from "@/stores/modules/map.module";

export default {
  name: "DiscoverProperties",
  components: {PropertyItemUser},
  setup(){
    const propertyStore = usePropertyStore();
    const mapStore  = useMapStore();
    mapStore.getUserPositionLngLat.then((res) => {
      propertyStore.fetchDiscoverProperties(0,res);
    });
    return{
      propertyStore,mapStore
    }
  },
  created() {
    this.loadPage(0);
  },
  computed:{
    userLocation(){
      return this.mapStore.userPosition;
    },
    properties(){
      return this.propertyStore.discoverProperties.content;
    },
    page(){
      return this.propertyStore.discoverProperties.currentPage;
    },
    loading(){
      return this.propertyStore.discoverProperties.loading;
    }
  },
  methods:{
    async loadPage(page) {
      let location = await this.userLocation;
      await this.propertyStore.fetchDiscoverProperties(page, location);
    }
  }
}
</script>

<template>
  <v-skeleton-loader
      v-if="loading"
      type="image"
  >

  </v-skeleton-loader>
  <div v-else-if="!properties || properties.length<=0">
    <div class="text-center">Keine Immobilien</div>
  </div>
  <div v-else style="gap:15px" class="d-flex justify-start flex-column">
    <PropertyItemUser v-for="property of properties" :key="property.id" :property="property"/>
    <v-pagination :start="0" v-model="page.number" :length="page.totalPages" @update:modelValue="loadPage"/>
  </div>

</template>

<style scoped>

</style>